import * as React from 'react';

import AssistantCapabilitiesOverview from './AssistantCapabilitiesOverview.tsx';
import { AGENT_CONFIG_STEPS, AGENT_FORM_DEFAULT_VALUES } from './config/ConfigSteps.tsx';
import { VOICE_AGENT_CONFIG_STEPS, VOICE_AGENT_FORM_STEPS } from '../../voice_agents/components/ConfigSteps.tsx';

export interface AssistantWizardStepProps {
    form: any;
    teamOptions?: any[];
    // the wizard creates a new agent: steps may show the backend defaults before the agent exists
    isNewAgent?: boolean;
    availableSkills?: any[];
    availableToolNames?: string[];
    availableToolProviders?: any[];
}

export interface AssistantWizardStep {
    title: string;
    description: string;
    component: React.ComponentType<AssistantWizardStepProps>;
    isValid?: (form: any) => boolean;
}

export const INBOX_ASSISTANT_FORM_DEFAULTS = {
    ...AGENT_FORM_DEFAULT_VALUES,
    deliveryMethod: 'auto',
    masterDataToolProvider: null,
    sharepointToolProvider: null,
    sftpKnowledgeSource: null,
    orderHistoryToolProvider: null,
};

export const INBOX_ASSISTANT_STEPS: AssistantWizardStep[] = [
    {
        title: 'assistants:wizard.basics.title',
        description: 'assistants:wizard.basics.description',
        component: AGENT_CONFIG_STEPS.details.component,
        isValid: AGENT_CONFIG_STEPS.details.isValid,
    },
    {
        title: 'assistants:wizard.skills.title',
        description: 'assistants:wizard.skills.description',
        component: AGENT_CONFIG_STEPS.skills.component,
        isValid: AGENT_CONFIG_STEPS.skills.isValid,
    },
    {
        title: 'assistants:wizard.capabilities.title',
        description: 'assistants:wizard.capabilities.description',
        component: ({ availableToolProviders }) => (
            <AssistantCapabilitiesOverview availableToolProviders={availableToolProviders ?? []} />
        ),
    },
];

export const PHONE_ASSISTANT_STEPS: AssistantWizardStep[] = VOICE_AGENT_FORM_STEPS.map((step) => {
    const config = VOICE_AGENT_CONFIG_STEPS[step];
    return {
        title: `voice_agents:${config.title}`,
        description: `voice_agents:${config.description}`,
        component: config.component,
        isValid: config.isValid,
    };
});
